import { uniqueId } from 'lodash'
import React, { FC } from 'react'

interface Props {
  distributions: {
    from: number,
    to: number,
    percent: number
  }[]
}

const Distribution: FC<Props> = (props) => {
  const {
    distributions,
  } = props

  return (
    <div className="ruler">
      {
        distributions.map((distribution, index) => (
          <React.Fragment key={uniqueId()}>
            <div
              style={{
                position: "absolute",
                top: "-13px",
                left: `${index * 20}%`,
                width: "20%",
                textAlign: "center",
                color: "#999",
                fontSize: "10px",
                lineHeight: "1em",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                }}
              >
                {distribution.percent}
                %
              </span>
            </div>
          </React.Fragment>
        ))
      }
      <div
        style={{
          width: "100%",
          height: "24px",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            height: "1px",
            width: "100%",
            backgroundColor: "#999",
            transform: "translateY(-50%)",
          }}
        />
        {
          distributions.map((_, index) => (
            <React.Fragment key={uniqueId()}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: `${index * 20}%`,
                  height: "14px",
                  width: "1px",
                  backgroundColor: "#999",
                  transform: "translateY(-50%)",
                }}
              />
            </React.Fragment>
          ))
        }
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "100%",
            height: "14px",
            width: "1px",
            backgroundColor: "#999",
            transform: "translateY(-50%)",
          }}
        />
      </div>
    </div>
  )
}

export default Distribution
